import type { AuditFilters } from '@/app/audit/auditDataClient';
import { PivotLink } from '@/components/pivots/PivotLink';

export interface AdminAuditPivotProps {
  filters?: AuditFilters;
  /** Current audit row ID for deep linking */
  currentRowId?: string;
}

export function AdminAuditPivot({
  filters = {},
  currentRowId,
}: AdminAuditPivotProps) {

  // Use new PivotLink pattern for consistency
  return (
    <PivotLink
      pivotId="admin-audit"
      context={{
        resourceId: currentRowId,
        extra: {
          orgId: 'current-org-id',
          actor: filters.actor,
          target: filters.target,
          action: filters.action,
          scope: filters.scope,
          outcome: filters.outcome,
          costClass: filters.costClass,
          timeStart: filters.timeRange?.start,
          timeEnd: filters.timeRange?.end,
        },
      }}
    />
  );
}
